const DICH_VU_DATA = {
	phau_thuat_tham_my: [
		{ value: 'nang_mui', text: 'Nâng mũi' },
		{ value: 'cat_mi_mat', text: 'Cắt mí mắt' },
		{ value: 'giam_beo', text: 'Giảm béo' },
		{ value: 'ham_mat', text: 'Hàm mặt' },
		{ value: 'nang_nguc', text: 'Nâng ngực' },
		{ value: 'nang_mong', text: 'Nâng mông' },
	],
	tre_hoa_dieu_tri_da: [
		{ value: 'cai_lao_3m', text: 'Cải lão 3M' },
		{ value: 'tre_hoa_da', text: 'Trẻ hóa & Điều trị da' },
		{ value: 'phun_xam_tham_my', text: 'Phun xăm thẩm mỹ' },
	],
	rang_ham_mat: [
		{ value: 'rang_su', text: 'Răng sứ' },
		{ value: 'nieng_rang', text: 'Niềng răng' },
		{ value: 'tri_sau_rang', text: 'Trị sâu răng' },
		{ value: 'trong_rang_imlpant', text: 'Trồng răng implant' },
		{ value: 'nha_khoa_tong_quat', text: 'Nha khoa tổng quát' },
	],
	ngoai_tong_quat: [
		{ value: 'nam_hoc', text: 'Nam học' },
		{ value: 'tiet_nieu', text: 'Tiết niệu' },
		{ value: 'tai_mui_hong', text: 'Tai mũi họng' },
		{ value: 'benh_ly_than', text: 'Bệnh lý thận' },
		{ value: 'dieu_tri_thoat_vi', text: 'Điều trị thoát vị' },
		{ value: 'long_nguc_mach_mau', text: 'Lồng ngực - Mạch máu' },
		{ value: 'benh_ly_tieu_hoa', text: 'Bệnh lý đường tiêu hóa' },
		{ value: 'chan_thuong_chinh_hinh', text: 'Chấn thương chỉnh hình' },
	],
	noi_tong_quat: [
		{ value: 'ho_hap', text: 'Hô hấp' },
		{ value: 'noi_tiet', text: 'Nội tiết' },
		{ value: 'phau_thuat_tuyen_giap', text: 'Phẫu thuật tuyến giáp' },
		{ value: 'huyet_hoc_truyen_mau', text: 'Huyết học - Truyền máu' },
	],
	dich_vu_khac: [
		{ value: 'tam_soat_ung_thu', text: 'Tầm soát ung thư' },
		{ value: 'bao_hiem_suc_khoe', text: 'Bảo hiểm sức khỏe' },
		{ value: 'tam_soat_suc_khoe_vip', text: 'Tầm soát sức khỏe VIP' },
	],
	khac: [{ value: 'khac', text: 'Khác' }],
};

const POST_ID_TO_KHOA = {
	76130: 'phau_thuat_tham_my',
	143321: 'phau_thuat_tham_my',
	570: 'phau_thuat_tham_my',
	74051: 'phau_thuat_tham_my',
	106306: 'phau_thuat_tham_my',
	131550: 'phau_thuat_tham_my',
	157872: 'phau_thuat_tham_my',
	159664: 'phau_thuat_tham_my',
	104211: 'phau_thuat_tham_my',
	153241: 'phau_thuat_tham_my',
	120882: 'phau_thuat_tham_my',
	165106: 'phau_thuat_tham_my',
	165957: 'phau_thuat_tham_my',
	103224: 'phau_thuat_tham_my',
	8993: 'phau_thuat_tham_my',
	119285: 'phau_thuat_tham_my',
	56837: 'phau_thuat_tham_my',
	158132: 'phau_thuat_tham_my',
	162063: 'phau_thuat_tham_my',
	85134: 'phau_thuat_tham_my',
	23340: 'tre_hoa_dieu_tri_da',
	38251: 'tre_hoa_dieu_tri_da',
	20725: 'tre_hoa_dieu_tri_da',
	153008: 'phau_thuat_tham_my',
	152913: 'phau_thuat_tham_my',
	153070: 'phau_thuat_tham_my',
};

const POST_ID_TO_DICH_VU = {
	76130: 'nang_mui',
	143321: 'nang_mui',
	570: 'nang_mui',
	74051: 'nang_mui',
	106306: 'nang_mui',
	131550: 'nang_mui',
	157872: 'nang_nguc',
	159664: 'nang_nguc',
	104211: 'nang_nguc',
	153241: 'nang_nguc',
	120882: 'nang_nguc',
	165106: 'nang_nguc',
	165957: 'nang_nguc',
	103224: 'nang_nguc',
	8993: 'nang_nguc',
	119285: 'nang_nguc',
	56837: 'nang_nguc',
	158132: 'nang_mong',
	162063: 'giam_beo',
	85134: 'cat_mi_mat',
	23340: 'tre_hoa_da',
	38251: 'tre_hoa_da',
	20725: 'tre_hoa_da',
	153008: 'ham_mat',
	152913: 'ham_mat',
	153070: 'ham_mat',
};

export default class HomeFormController {
	constructor() {
		this.initialized = false;
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.initModalOverlay();
		this.initDependentSelects();
		this.maybeAutoOpenMappedPopup();
	}

	initModalOverlay() {
		const modalOverlay = document.getElementById('modalOverlayt3');
		const closeButton = document.querySelector('.close-modal-btn-3');

		if (!modalOverlay) {
			return;
		}

		document.querySelectorAll('.open-modal-btn-3').forEach((button) => {
			button.addEventListener('click', () => this.openOverlay(button));
		});

		if (closeButton) {
			closeButton.addEventListener('click', () => this.closeOverlay());
		}

		modalOverlay.addEventListener('click', (event) => {
			if (event.target === modalOverlay) {
				this.closeOverlay();
			}
		});
	}

	initDependentSelects() {
		document.querySelectorAll('.select-khoa').forEach((selectKhoa) => {
			selectKhoa.addEventListener('change', () => {
				this.populateServiceSelect(selectKhoa, selectKhoa.value);
			});
		});
	}

	maybeAutoOpenMappedPopup() {
		const modalOverlay = document.getElementById('modalOverlayt3');
		const postId = document.body.getAttribute('data-post-id');
		const khoaValue = POST_ID_TO_KHOA[postId];

		if (!modalOverlay || !postId || !khoaValue) {
			return;
		}

		if (document.getElementById('modal-overlay-vongxoay') || document.querySelector('.vong-xoay-popup-result-overlay')) {
			return;
		}

		window.setTimeout(() => {
			this.openOverlay();
			document.querySelectorAll('.select-khoa').forEach((selectKhoa) => {
				selectKhoa.value = khoaValue;
				this.populateServiceSelect(
					selectKhoa,
					khoaValue,
					POST_ID_TO_DICH_VU[postId] || ''
				);
			});
		}, 2500);
	}

	populateServiceSelect(selectKhoa, khoaValue, selectedValue = '') {
		const selectDichVu = selectKhoa.closest('form')?.querySelector('.select-dichvu');

		if (!selectDichVu) {
			return;
		}

		selectDichVu.innerHTML = '<option value="khong_chon_dich_vu">Chọn Dịch Vụ</option>';

		(DICH_VU_DATA[khoaValue] || []).forEach((service) => {
			const option = document.createElement('option');
			option.value = service.value;
			option.textContent = service.text;
			option.selected = service.value === selectedValue;
			selectDichVu.appendChild(option);
		});
	}

	openOverlay(trigger = null) {
		const modalOverlay = document.getElementById('modalOverlayt3');
		if (trigger) {
			if(trigger.classList.contains('open-modal-bs-request-form')) {
				const textarea = modalOverlay.querySelector('.bs-request-form__textarea');
				const title = modalOverlay.querySelector('.modal-content-title');
				if(textarea) {
					textarea.classList.toggle('textarea-active');
					title.textContent = 'Điền thông tin để tư vấn miễn phí';
				}

			};
		}

		if (modalOverlay) {
			modalOverlay.setAttribute('aria-hidden', 'false');
			modalOverlay.classList.add('active-popup-t3');
		}
		document.body.style.overflow = 'hidden';
	}

	closeOverlay(trigger = null) {
		const modalOverlay = document.getElementById('modalOverlayt3');
		if (modalOverlay) {
			modalOverlay.setAttribute('aria-hidden', 'true')
			modalOverlay.classList.remove('active-popup-t3');
		}
		document.body.style.overflow = '';
	}
}
